import { Advertisable, BaseApi, Environment, User } from '@nextroll/ar-base-api';

const adrollApi = new BaseApi('/api/v1/', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

/**
 * fetch basic bootstrap data
 */
export const getBootstrapData = async (
    advertisableEid: string
): Promise<{ advertisable: Advertisable; actualUser: User; user: User }> => {
    const data = (await adrollApi.get('bootstrap', { advertisable: advertisableEid }))?.results;
    return {
        advertisable: data.advertisable,
        actualUser: data.actual_user,
        user: data.user,
    };
};

/**
 * Get advertisable users
 * @param advertisableEid The user's associated advertisable EID.
 * @param signal Optional abortController signal to be able to cancel the fetch
 */
export const getOrganizationUserEmails = async (
    advertisableEid: string,
    signal?: AbortSignal,
): Promise<string[]> => {
    const organization = (await adrollApi.get('advertisable/get', { advertisable: advertisableEid }, signal))?.results.organization;
    const users = (await adrollApi.get('organization/get_users', { organization, _escape: false }, signal))?.results;
    return (users || []).map((user: { email: string }) => user.email);
};
